import { createApiAction } from '@app/packages/api/utils'
import type { V3GetPlacesReverseParams, V3GetPlacesSuggestParams } from '@app/packages/api/v3/types/params'
import type { V3GetPlacesReverseResponse, V3GetPlacesSuggestResponse } from '@app/packages/api/v3/types/responses'

/** Public. Without `near` a signed-in caller is ranked around their profile place, a guest around their IP's city. */
export const getPlacesSuggest = (params: V3GetPlacesSuggestParams) =>
  createApiAction('getPlacesSuggest', dispatch =>
    dispatch<V3GetPlacesSuggestResponse>({
      endpoint: `/api/v3/places/suggest?${buildPlacesSuggestQuery(params)}`,
      method: 'GET',
    })
  )

/** Public. The coordinates go as they are: finding the address at a point is the whole request. */
export const getPlacesReverse = ({ latitude, longitude }: V3GetPlacesReverseParams) =>
  createApiAction('getPlacesReverse', dispatch =>
    dispatch<V3GetPlacesReverseResponse>({
      endpoint: `/api/v3/places/reverse?${buildQuery({ latitude: String(latitude), longitude: String(longitude) })}`,
      method: 'GET',
    })
  )

/** Two decimals are all the server reads of the hint, and all of a position it is meant to get. */
const buildPlacesSuggestQuery = ({ q, kind, near }: V3GetPlacesSuggestParams): string =>
  buildQuery({
    q,
    'filter[kind]': kind,
    latitude: near?.latitude.toFixed(2),
    longitude: near?.longitude.toFixed(2),
  })

const buildQuery = (params: Record<string, string | undefined>): string => {
  const search = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) if (value !== undefined) search.set(key, value)
  return search.toString()
}
